'use strict';

var _ = require('lodash');
var ComboboxExampleController = function ComboboxExampleController($scope) {
  $scope.list = {
    custom: [{
      label: 'Create New...',
      action: function action(combobox) {
        var item = window.prompt('New item', 'Item custom');
        if (item) {
          $scope.list.simpleBigCustom.push(item);
          combobox.addItem(item);
        }
      }
    }, {
      label: 'Default',
      action: function action(combobox) {
        return combobox.selectItem('Default');
      }
    }],
    simpleSmall: _.range(5).map(function (item) {
      return 'Item ' + (item + 1);
    }),
    simpleBig: _.range(10000).map(function (item) {
      return 'Item ' + (item + 1);
    }),
    simpleBigCustom: _.range(10000).map(function (item) {
      return 'Item ' + (item + 1);
    }),
    objectBig: _.range(10000).map(function (item) {
      return {
        label: 'Item ' + (item + 1),
        id: item
      };
    })
  };
  $scope.model = {
    simpleSmall: '',
    simpleBig: '',
    custom: '',
    typeAhead: '',
    multi: [],
    multi2: []
  };
};
ComboboxExampleController.$inject = ['$scope'];
module.exports = ComboboxExampleController;